export default "__VITE_ASSET__OXtIFG2v__"